export default defineAppConfig({
  'ui': {
    'colors': {
      'primary': 'orange',
    }
  }
})
